import styled from 'styled-components';
import HashLink from 'shared/ui/HashLink/HashLink';
import { Link as LinkReactRouterDom } from 'react-router';

export const Container = styled.header`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 65px;
    padding: 0 20px;
    border-bottom: 1px solid #edeff2;
    background-color: #ffffff;
    color: #4b5563;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    @media (max-width: 767px) {
        height: 52px;
        padding: 0 10px;
    }
`;

export const Inner = styled.div`
    width: 100%;
    max-width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Image = styled.img`
    height: 24px;
    width: auto;
    flex-shrink: 0;
`;

export const HeaderLogo = styled(LinkReactRouterDom)`
    display: flex;
    align-items: center;
    min-height: 48px;
`;

export const LinkHeaderLogo = styled(HashLink)`
    display: flex;
    align-items: center;
    text-decoration: none;
    min-height: 48px;
`;

export const BrandLogo = styled.figure`
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    ${Image} {
        height: auto;
        max-width: 94px;
    }
    a {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const Description = styled.figcaption`
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #4b5563;
    margin-right: 8px;
`;

export const HeaderNavigation = styled.nav``;

export const NavList = styled.ul`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NavItem = styled.li`
    margin: 0 48px 0 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
        margin-right: 0;
    }
`;

export const Link = styled(HashLink)`
    margin: 0;
    padding: 14px 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #4b5563;
    text-decoration: none;
`;
